import { render } from "./SetTranslationPopupComponent.vue?vue&type=template&id=65ec826f&scoped=true"
import script from "./SetTranslationPopupComponent.vue?vue&type=script&lang=js"
export * from "./SetTranslationPopupComponent.vue?vue&type=script&lang=js"

import "./SetTranslationPopupComponent.vue?vue&type=style&index=0&id=65ec826f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65ec826f"

export default script